import React from 'react';
import cx from 'classnames';

import { getRunningBuildId } from '~helpers/buildId';

import Cities from './cities';
import Socials from './socials';
import Copyright from './copyright';

import './style.scss';

const Footer = ({ displayCities, displayNeighborhoods = false, isCityPage = false, citySlug = null }) => {
  const className = cx('c-footer', { 'c-footer--city-page': isCityPage });

  return (
    <footer className={className} data-build-id={getRunningBuildId()}>
      {displayCities && <Socials key="socials" />}
      {displayCities && <Cities key="cities" displayNeighborhoods={displayNeighborhoods} citySlug={citySlug} />}
      {!displayCities && <Copyright key="copyright" />}
      {/* <Socials key="socials" displayCities={displayCities} />
      <Cities key="cities" displayNeighborhoods={displayNeighborhoods} displayCities={displayCities} citySlug={citySlug} />
      {!displayCities && <Copyright key="copyright" />} */}
    </footer>
  );
};

export default Footer;
